import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { WithTranslation, withTranslation } from 'react-i18next';
import { IDriverDebtProps } from '../../types/propTypes/propTypes';
import { IDriverDebtState } from '../../types/stateTypes/stateTypes';
import { Common } from '../../utils/constants';
import { Can } from '../../ability';
import DriverDebtContent from './DriverDebtContent';
import { companyNameReplace } from '../../utils';

class DriverDebt extends Component<IDriverDebtProps & WithTranslation, IDriverDebtState> {
    constructor(props: IDriverDebtProps & WithTranslation) {
        super(props);

        this.state = {
            filterState: {
                rowsPerPage: 10,
                currentPage: 1,
                sortColumn: 'creation_date_time',
                sortOrder: 'desc',
                offset: 0,
            },
            pastLettersFilterState: {
                plRowsPerPage: 10,
                plCurrentPage: 1,
                plSortColumn: 'creation_date_time',
                plSortOrder: 'desc',
                plOffset: 0,
            },
        };
    }

    updateFilterState = (data, callBack: Function | null = null) => {
        this.setState({ ...this.state, filterState: { ...this.state.filterState, ...data } }, () => {
            if (callBack) {
                callBack();
            }
        });
    };

    updatePLFilterState = (data, callBack: Function | null = null) => {
        this.setState(
            { ...this.state, pastLettersFilterState: { ...this.state.pastLettersFilterState, ...data } },
            () => {
                if (callBack) {
                    callBack();
                }
            },
        );
    };

    render() {
        return (
            <>
                <Helmet>
                    <title>{companyNameReplace(this.props.t('driverDebt.title'))}</title>
                </Helmet>
                <Can I={Common.Actions.CAN_VIEW} a={Common.Modules.DRIVERS.DRIVER_DEBT}>
                    <DriverDebtContent
                        t={this.props.t}
                        updateFilterState={this.updateFilterState}
                        filterState={this.state.filterState}
                        updatePLFilterState={this.updatePLFilterState}
                        pastLettersFilterState={this.state.pastLettersFilterState}
                    />
                </Can>
            </>
        );
    }
}

export default withTranslation()(DriverDebt);
